// import {Message} from 'element-ui'
import {MessageBox} from 'element-ui'
function msgWarning (message, title = '错误', big = false) {
  if (Object.prototype.toString.call(message).indexOf('Error') > -1) {
    message = message.message
  }
  // console.error(message)
  let otherClass = ''
  if (big) otherClass = 'big-warning'
  MessageBox.alert(message, title, {
    showConfirmButton: false,
    // closeOnClickModal: true,
    closeOnPressEscape: true,
    customClass: 'msgWarning' + (big ? ' ' + otherClass : ''),
    dangerouslyUseHTMLString: true // 允许html
  })
}
export default msgWarning

// import msgWarning from '@/tools/msgwarning.js'
// msgWarning()
// msgWarning(res.desc)



// WEBPACK FOOTER //
// ./src/tools/msgwarning.js